import { render, staticRenderFns } from "./InstagramPositions.vue?vue&type=template&id=6ac80fcb&scoped=true&"
import script from "./InstagramPositions.vue?vue&type=script&lang=js&"
export * from "./InstagramPositions.vue?vue&type=script&lang=js&"
import style0 from "./InstagramPositions.vue?vue&type=style&index=0&id=6ac80fcb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac80fcb",
  null
  
)

export default component.exports